import { useSearchQueryParams } from '@/features/shared/hooks/search'
import { fetchPlaRegionById } from '@/features/shop/services/PLA/fetchers'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const plaRegionByIdQueryOptions = (regionId: string) =>
  queryOptions({
    queryKey: ['PLA Region', { regionId }],
    queryFn: fetchPlaRegionById,
  })

export const useQueryPlaRegionById = () => {
  const { region_id } = useSearchQueryParams()
  const regionId = typeof region_id === 'string' ? region_id : ''

  return useQuery({
    ...plaRegionByIdQueryOptions(regionId),
    enabled: Boolean(regionId),
  })
}
